import { useCallback, useEffect, useMemo } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

type Props = {
  cause_shortener?: string;
};

const useUpdateCauseUrl = ({ cause_shortener }: Props) => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (cause_shortener) {
      if (cause_shortener !== uuid) {
        navigate(`/causes/${cause_shortener}${location.search}`, { replace: true });
      }
    }
  }, [cause_shortener, location.search, navigate, uuid]);
};

const usePrettierCauseUrl = ({ cause }: { cause?: { shortener?: string; uuid: string } }) => {
  const navigate = useNavigate();
  const prettyCauseUrl = useMemo(() => cause?.shortener ?? cause?.uuid ?? '', [cause]);

  const navigateToPrettyCauseUrl = useCallback(
    () => navigate(`/causes/${prettyCauseUrl}`),
    [cause, navigate]
  );

  return { navigateToPrettyCauseUrl, prettyCauseUrl };
};

export { usePrettierCauseUrl, useUpdateCauseUrl };
